import { INewbuilding } from '../../types/newbuilding';

export function getNewbuildingIsUpcomingSale(newbuilding: INewbuilding) {
  const { isUpcomingSale = false } = newbuilding;

  return isUpcomingSale;
}
